// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__8N2ep","buttons":"RemoveExpirationActionButtons_buttons__3I3I6"};